import {Directive, Input, TemplateRef} from '@angular/core';

@Directive({
    selector: '[sharedTableCustomFilter]',
    standalone: false
})
export class TableCustomFilterDirective {
  constructor(public templateRef: TemplateRef<any>) { }
}
